import React from 'react';
import { TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField';
import { TextFieldVariants } from '@mui/material/TextField';

export const TextFieldCompat = <Variant extends TextFieldVariants>(
  props: {
    variant?: Variant;
  } & Omit<TextFieldProps, 'variant'>,
) => {
  return (
    <TextField
      size={'small'}
      slotProps={{
        htmlInput: {
          className: 'box-content',
        },
        input: {
          className: 'box-content',
        },
        inputLabel: {
          className: 'box-content',
        },
      }}
      {...props}
    />
  );
};
